'use client';

import { useQuery } from '@tanstack/react-query';
import apiService from '../services/api';
import { CONVERSATIONS_QUERY_KEY } from '../lib/messagingQueryCache';
import { CONVERSATIONS_LIST_POLL_MS } from '../lib/pollingConstants';
import { resolvePollIntervalMs, type PollingEndpointKey } from '../lib/pollingManager';
import { usePollingGate } from './usePollingGate';

const ENDPOINT_KEY: PollingEndpointKey = 'conversations-list';

type Options = {
  enabled?: boolean;
  /** Poll uniquement sur pages messagerie actives. */
  poll?: boolean;
  /** Liste des conversations archivées (prestataire). */
  archived?: boolean;
  /** Liste restitués / livraisons (prestataire). */
  restored?: boolean;
  /** Tous les fils (actifs, archivés, restitués…) — recherche / non-lus. */
  all?: boolean;
};

export function useConversationsListQuery(options?: Options) {
  const enabled = options?.enabled ?? true;
  const poll = options?.poll ?? false;
  const archived = options?.archived ?? false;
  const restored = options?.restored ?? false;
  const all = options?.all ?? false;
  const { allowPolling } = usePollingGate();

  return useQuery({
    queryKey: [...CONVERSATIONS_QUERY_KEY, { archived, restored, all }],
    queryFn: () => apiService.getConversations({ archived, restored, all }),
    enabled,
    retry: 0,
    staleTime: 30_000,
    refetchOnWindowFocus: false,
    refetchIntervalInBackground: false,
    refetchInterval: resolvePollIntervalMs(
      poll ? CONVERSATIONS_LIST_POLL_MS : false,
      ENDPOINT_KEY,
      allowPolling,
    ),
    meta: { pollingEndpoint: ENDPOINT_KEY },
  });
}
